import IssueJobForm from '@/models/jobs/issues/IssueJobForm'
import type { TIssuesState } from '@/types/state-types'

export default <TIssuesState>{
  issueForm: new IssueJobForm(),
  isIssueFormLoading: false
}
